import { render, staticRenderFns } from "./ParticleBoxViz.vue?vue&type=template&id=0b9b5a0c&scoped=true"
import script from "./ParticleBoxViz.vue?vue&type=script&lang=js"
export * from "./ParticleBoxViz.vue?vue&type=script&lang=js"
import style0 from "./ParticleBoxViz.vue?vue&type=style&index=0&id=0b9b5a0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9b5a0c",
  null
  
)

export default component.exports